/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import type { ContactDetails } from '../models/ContactDetails';
import type { Manufacturer } from '../models/Manufacturer';
import type { PaginatedManufacturers } from '../models/PaginatedManufacturers';
import type { SearchOptions } from '../models/SearchOptions';
import type { SearchPart } from '../models/SearchPart';

export class SearchService {
  /**
   * @param parts
   * @param countries
   * @param certificationIds
   * @param companySizeCategories
   * @param partTypes
   * @param hasMetrologyMachines
   * @param isVerified
   * @param hasCapacity
   * @param excludeEncodedUrls
   * @param excludePartfoxIds
   * @param page
   * @param pageSize
   * @returns PaginatedManufacturers
   * @throws ApiError
   */
  public static manufacturerSearchControllerGetManufacturers(
    parts?: Array<SearchPart>,
    countries?: Array<string>,
    certificationIds?: Array<string>,
    companySizeCategories?: Array<string>,
    partTypes?: Array<string>,
    hasMetrologyMachines?: boolean,
    isVerified?: boolean,
    hasCapacity?: boolean,
    excludeEncodedUrls?: Array<string>,
    excludePartfoxIds?: Array<number>,
    page: number = 1,
    pageSize: number = 10,
  ): CancelablePromise<PaginatedManufacturers> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/search/manufacturers',
      query: {
        parts: parts,
        countries: countries,
        certificationIds: certificationIds,
        companySizeCategories: companySizeCategories,
        partTypes: partTypes,
        hasMetrologyMachines: hasMetrologyMachines,
        isVerified: isVerified,
        hasCapacity: hasCapacity,
        excludeEncodedUrls: excludeEncodedUrls,
        excludePartfoxIds: excludePartfoxIds,
        page: page,
        pageSize: pageSize,
      },
    });
  }

  /**
   * @param requestBody
   * @param xNoTracking Disable MAN tracking appearance (in results list)
   * @returns PaginatedManufacturers
   * @throws ApiError
   */
  public static manufacturerSearchControllerGetManufacturersPost(
    requestBody: SearchOptions,
    xNoTracking?: 'true' | 'false',
  ): CancelablePromise<PaginatedManufacturers> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/search/manufacturers',
      headers: {
        'X-No-Tracking': xNoTracking,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @param encodedUrl
   * @param contactType
   * @returns ContactDetails
   * @throws ApiError
   */
  public static manufacturerSearchControllerGetManufacturerContactDetails(
    encodedUrl: string,
    contactType: string,
  ): CancelablePromise<ContactDetails> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/search/manufacturers/{encodedUrl}/contact-details',
      path: {
        encodedUrl: encodedUrl,
      },
      query: {
        contactType: contactType,
      },
    });
  }

  /**
   * @param uuid
   * @returns Manufacturer
   * @throws ApiError
   */
  public static manufacturerSearchControllerGetManufacturerSearchData(
    uuid: string,
  ): CancelablePromise<Manufacturer> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/search/manufacturers/{uuid}',
      path: {
        uuid: uuid,
      },
    });
  }

  /**
   * @param text
   * @returns Manufacturer
   * @throws ApiError
   */
  public static manufacturerSearchControllerGetManufacturersByText(
    text: string,
  ): CancelablePromise<Array<Manufacturer>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/search/manufacturers/by-text/{text}',
      path: {
        text: text,
      },
    });
  }
}
